import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import {
    getAvailability,
    getContractLevel,
    getContractMode,
    getContractTime,
    getContractType,
    getCountries,
    getCurrency,
    getEducationLevel,
    getEducationStatus,
    getExpRange,
    getGender,
    getSector,
    getIndustry,
    getSubIndustry,
    getSubSubIndustry,
    getLanguage,
    getSearchUrgency, getTimezone, getValue,
    getWorkLocation, getModules,
    getSetupData
} from '../../redux/actions/List'
import {setCommonState} from '../../redux/actions/Common'


const PageContainer = ({children}) => {
    const dispatch = useDispatch()

    const {loading, scrollToTop, locale} = useSelector(({common}) => common)
    const {token} = useSelector(({auth}) => auth)
    const {
        countries,
        language,
        setupData
    } = useSelector(({list}) => list)
    const {user} = useSelector(({auth}) => auth)

    const [fullLoading, setFullLoading] = useState(false)

    useEffect(() => {
        if (scrollToTop) {
            document.getElementsByClassName('App')?.[0]?.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            })
            dispatch(setCommonState({scrollToTop: false}))
        }
    }, [scrollToTop])

    useEffect(() => {
        if (!setupData && user?.type) {
            dispatch(getSetupData(token, locale?.short))
        }
    }, [locale, setupData, user])

    useEffect(() => {
        if (!countries || countries?.length === 0) {
            dispatch(getCountries(token, {}, locale))
        }
    }, [countries, locale])

    useEffect(() => {
        if (!language || language?.length === 0) {
            dispatch(getLanguage(token, {}, locale))
        }
    }, [language, locale])


    useEffect(() => {
        if ( !setupData ) {
            setFullLoading(false)
        }
    }, [
        setupData
    ])

    return (
        <div>
            {children}

            <Backdrop
                sx={{color: '#0284c7', backgroundColor: 'white', opacity: '0.5 !important' , zIndex: (theme) => theme.zIndex.drawer + 1}}
                open={loading}
                invisible
            >
                <CircularProgress size={100} color="inherit"/>
            </Backdrop>
        </div>
    )
}

export default PageContainer
